var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DPrinting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61,192.06c-3.93,0-7.13-6.21-7.13-8.61V140.12c0-2.41,3.2-9.46,7.13-9.46H154.3c3.93,0,7.12,7.05,7.12,9.46v43.33c0,2.4-3.19,8.61-7.12,8.61Zm0-61.4a7.16,7.16,0,0,1-7.13-7.18V36.57A7.16,7.16,0,0,1,61,29.39H154.3a7.15,7.15,0,0,1,7.12,7.18v86.91a7.15,7.15,0,0,1-7.12,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.16,146.16a3.09,3.09,0,1,1-3.08-3.11,3.09,3.09,0,0,1,3.08,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.92,146.16a3.09,3.09,0,1,1-3.09-3.11,3.1,3.1,0,0,1,3.09,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110,146.16a3.09,3.09,0,1,1-3.08-3.11,3.09,3.09,0,0,1,3.08,3.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.08,72.56s-3.18-21.82,25.47-23.1,24.83-19.25,24.83-19.25m-46.65,69.95H97.12a5.76,5.76,0,0,1-5.74-5.79v-16a5.76,5.76,0,0,1,5.74-5.79h7.61a5.77,5.77,0,0,1,5.75,5.79v16a5.77,5.77,0,0,1-5.75,5.79m5.9-9.63H160.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.91 102.85 98.81 102.85 99.86 104.68 100.91 106.51 101.97 104.68 103.01 102.85 100.91 102.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 76.62,
    y1: 125.83,
    x2: 139.26,
    y2: 125.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.93,80.27H90.24m20.38,0H160.3M53.93,90.53H90.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DPrinting);
export default __webpack_public_path__ + "static/media/_3D_PRINTING.def735e43682143e3e88befdbfd36bc8.svg";
export { ForwardRef as ReactComponent };